export enum FileUploadingEnum {
  AllAddedToQueue = 'allAddedToQueue',
  AddedToQueue = 'addedToQueue',
  Cancel = 'cancel',
  Uploading = 'uploading',
  Removed = 'removed',
  RemovedAll = 'removedAll',
  Remove = 'remove',
  Rejected = 'rejected',
  Done = 'done'
}
